var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.914,17l-6-6H30.5V9.899c2.279-0.465,4-2.484,4-4.899c0-2.757-2.243-5-5-5s-5,2.243-5,5c0,2.414,1.721,4.434,4,4.899V11  h-7.859c-1.732,0-3.141,1.409-3.141,3.142V17h-3.414l-6,6l6,6H28.5v21h-5v4h-3v6h18v-6h-3v-4h-5V29h8.859  c1.732,0,3.141-1.409,3.141-3.142V23h3.414L51.914,17z M26.5,5c0-1.654,1.346-3,3-3s3,1.346,3,3s-1.346,3-3,3S26.5,6.654,26.5,5z   M36.5,56v2h-14v-2h1h12H36.5z M33.5,54h-8v-2h8V54z M40.5,25.858c0,0.63-0.512,1.142-1.141,1.142H14.914l-4-4l4-4H17.5h21.859  c0.629,0,1.141,0.512,1.141,1.142V23V25.858z M42.5,21v-0.858c0-1.732-1.409-3.142-3.141-3.142H19.5v-2.858  c0-0.63,0.512-1.142,1.141-1.142h24.445l4,4l-4,4H42.5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3a444d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/Tip.ccbc447807d4a1a7faa47f4086949a2b.svg";
export { ForwardRef as ReactComponent };